export type PageBgSize = "cover" | "contain" | "100%" | "auto";
export type PageBgMode = "fixed" | "parallax_tall";

export type PageBgSettings = {
  url: string;
  color: string;
  size: PageBgSize;
  posX: number;
  posY: number;
  mode: PageBgMode;
};

export const PAGE_KEYS = [
  "home",
  "shop",
  "product",
  "about",
  "journal",
  "contact",
  "gifts",
  "wishlist",
  "account",
  "collection-large",
  "collection-ladybag",
  "ambassadors",
  "new-product",
] as const;
export type PageKey = (typeof PAGE_KEYS)[number];

/** مفتاح صفحة صالح: ثابت من PAGE_KEYS، أو مفتاح صفحة منتج جديد `new-product:<slug>`. */
export function isPageKeyLike(key: string): boolean {
  if ((PAGE_KEYS as readonly string[]).includes(key)) return true;
  return /^new-product:[a-z0-9-]{1,100}$/.test(key);
}



export const DEVICE_KEYS = ["all", "mobile", "desktop"] as const;
export type DeviceKey = (typeof DEVICE_KEYS)[number];

export const MARKET_KEYS = ["all", "SA", "AE", "KW", "QA", "BH", "OM", "IQ", "US", "ROW"] as const;
export type MarketKey = (typeof MARKET_KEYS)[number];

export type VariantKey = `${DeviceKey}:${MarketKey}`;
export type PageVariants = Partial<Record<VariantKey, PageBgSettings>>;

export function makeVariantKey(device: DeviceKey, market: MarketKey): VariantKey {
  return `${device}:${market}` as VariantKey;
}

export function resolveVariant(
  variants: PageVariants | undefined,
  device: "mobile" | "desktop",
  market: Exclude<MarketKey, "all">,
): PageBgSettings | null {
  if (!variants) return null;
  const candidates: VariantKey[] = [
    `${device}:${market}` as VariantKey,
    `${device}:all` as VariantKey,
    `all:${market}` as VariantKey,
    "all:all",
  ];
  for (const key of candidates) {
    const value = variants[key];
    if (value && (value.url || value.color)) return value;
  }
  return null;
}